import React, { useEffect } from "react";
import { ConnectedProps, connect } from "react-redux";
import {
  PreliquidationParamsMiddlewareType,
  sendAccountinMiddlewareType,
} from "sagas/types/preliquidation";
import { AppDispatch, RootState } from "store";
import { Preliquidation } from "./Preliquidation";
import {
  actions as preliActions,
  preliquidationSelector,
} from "../../reducers/preliquidation";
import { actions as notificationActions } from "../../reducers/notification";
import { PreliquidationContainerProps } from "./types";
import { NotificationStateType } from "reducers/types/notification";
import {
  PreliquidationFilterExtraType,
  PreliquidationFiltersType,
} from "./filter/types";
import "./i18n";
import { useTranslation } from "react-i18next";

const PreliquidationContainer = (
  props: PreliquidationContainerProps & ConnectorProps
): JSX.Element => {
  const { t } = useTranslation();
  useEffect(() => {
    props.resetAllSelected();
    props.setCollapseTable(true);
    const { filters, filtersExtra } = props;
    props.getPreliquidations({ ...filters, ...filtersExtra });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const approveInvoices = () => props.getPendingApprovalPresettlements();

  const sendToAccounting = () => {
    const { numberOfPreliSelected: n } = props;
    const word = t(`presettlements:presettlement${n > 1 ? "s" : ""}`);
    props.showNotification({
      level: "warning",
      title: t("presettlements:sendToAccountingTitle"),
      body: t("presettlements:sendToAccountingMessage", {
        quantity: `${n} ${word}`,
      }),
      onCancelLabel: "global:cancel",
      onConfirmLabel: "presettlements:send",
      onConfirm: () =>
        props.sendAccounting({
          presettlements: props.preliquidationsSelected.map((item) => {
            return item.id;
          }),
        }),
    });
  };

  return (
    <Preliquidation
      {...props}
      sendToAccounting={sendToAccounting}
      approveInvoices={approveInvoices}
      testId="peliquidation"
    />
  );
};

const mapStateToProps = (state: RootState) => ({
  preliquidations: preliquidationSelector(state).preliquidations,
  isExportDisabled: preliquidationSelector(state).exportDisabled,
  filters: preliquidationSelector(state).filters,
  filtersExtra: preliquidationSelector(state).filtersExtra,
  filtersExtraSeeMore: preliquidationSelector(state).filtersExtraSeeMore,
  seeMore: preliquidationSelector(state).seeMore,
  preliquidationsSelected:
    preliquidationSelector(state).preliquidationsSelected,
  numberOfPreliSelected:
    preliquidationSelector(state).preliquidationsSelected.length,
  anyPreliquidationSelected:
    preliquidationSelector(state).preliquidationsSelected.length > 0,
});

const mapDispatchToProps = (dispatch: AppDispatch) => ({
  getPreliquidationsExport: (
    params: PreliquidationParamsMiddlewareType,
    element: HTMLElement
  ) => {
    element.blur();
    dispatch(preliActions.getPreliquidationsExportRequest(params));
  },
  getPreliquidations: (params: PreliquidationParamsMiddlewareType) => {
    dispatch(preliActions.getPreliquidationsRequest(params));
  },
  setPreliquidationFilters: (params: PreliquidationFiltersType) => {
    dispatch(preliActions.setPreliquidationFilters(params));
  },
  setPreliquidationExtraFilters: (params: PreliquidationFilterExtraType) => {
    dispatch(preliActions.setPreliquidationExtraFilters(params));
  },
  getMorePreliquidations: (params: PreliquidationParamsMiddlewareType) => {
    dispatch(preliActions.getMorePreliquidationsRequest(params));
  },
  resetAllSelected: () => {
    dispatch(preliActions.resetAllSelected());
  },
  showNotification: (content: NotificationStateType) => {
    dispatch(notificationActions.showNotification(content));
  },
  sendAccounting: (params: sendAccountinMiddlewareType) => {
    dispatch(preliActions.sendAccountingRequest(params));
  },

  getPendingApprovalPresettlements: () => {
    dispatch(preliActions.getPendingApprovalPresettlementsRequest());
  },
  setCollapseTable: (collapse: boolean) => {
    dispatch(preliActions.setCollapseTable(collapse));
  },
});

const connector = connect(mapStateToProps, mapDispatchToProps);

type ConnectorProps = ConnectedProps<typeof connector>;

export default connector(PreliquidationContainer);
